import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function FeaturedDecisions() {
  const {
    t
  } = useLanguage();
  const decisions = t('featured.cards') as any[];
  return <section className="py-20 md:py-32 relative z-10" data-id="element-18">
      <div className="max-w-7xl mx-auto px-5 sm:px-6" data-id="element-19">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-16 gap-6" data-id="element-20">
          <div data-id="element-21">
            <h2 className="text-[40px] leading-[1.05] md:text-4xl font-display font-medium mb-4" data-id="element-22">
              {t('featured.title')}
            </h2>
            <p className="text-white/50 text-[18px] leading-[1.5] md:text-lg max-w-xl font-light" data-id="element-23">
              {t('featured.subtitle')}
            </p>
          </div>
          <button className="text-sm font-medium text-white/70 hover:text-white transition-colors flex items-center gap-2 w-fit" data-id="element-24">
            {t('featured.viewAll')} <ArrowUpRight className="w-4 h-4" data-id="element-25" />
          </button>
        </div>

        <div className="flex overflow-x-auto snap-x snap-mandatory md:grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 pb-8 md:pb-0 -mx-5 px-5 sm:mx-0 sm:px-0 hide-scrollbar" data-id="element-26">
          {decisions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group flex flex-col h-full glass-panel p-7 md:p-8 rounded-[2rem] border border-white/5 md:hover:border-white/10 md:hover:bg-surface/60 transition-all duration-500 cursor-pointer relative overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.2)] md:hover:shadow-[0_12px_40px_rgba(0,0,0,0.4)] md:hover:-translate-y-1 min-w-[85vw] max-w-[340px] md:min-w-0 md:max-w-none snap-center shrink-0" data-id="element-27">
              <div className="absolute inset-0 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)] rounded-[2rem] pointer-events-none" data-id="element-28" />
              <div className="absolute inset-0 bg-gradient-to-br from-white/[0.02] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-29" />
              <div className="flex items-center justify-between mb-8 relative z-10" data-id="element-30">
                <div className="px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs font-medium text-white/80 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]" data-id="element-31">
                  {item.category}
                </div>
                <div className="text-xs text-white/40 font-mono uppercase tracking-wider" data-id="element-32">
                  {item.readTime}
                </div>
              </div>

              <div className="flex-1 flex flex-col" data-id="element-33">
                <h3 className="text-2xl font-display font-medium text-white/90 group-hover:text-white transition-colors leading-snug mb-6" data-id="element-34">
                  {item.title}
                </h3>

                <div className="mt-auto pt-6 border-t border-white/5 space-y-4" data-id="element-35">
                  <div className="flex items-center justify-between" data-id="element-36">
                    <span className="text-sm text-white/50 font-light" data-id="element-37">
                      {t('featured.labels.confidence')}
                    </span>
                    <span className="text-sm font-medium text-accent" data-id="element-38">
                      {item.confidence}
                    </span>
                  </div>
                  <div className="flex flex-col gap-1" data-id="element-39">
                    <span className="text-xs text-white/40 font-mono uppercase tracking-wider" data-id="element-40">
                      {t('featured.labels.recommendation')}
                    </span>
                    <span className="text-sm text-white/80 font-medium" data-id="element-41">
                      {item.recommendation}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}